module.exports = __webpack_public_path__ + "img/channel_setup_google.dff3fe8.svg";